import React from 'react';
import { Link } from 'react-router-dom';
const logo = process.env.PUBLIC_URL + '/pelicanplanner-logo.png';

function MobileHeader({ user, onLogout }) {
  return (
    <header className="mobile-header">
      <Link to="/dashboard" className="mobile-header-brand">
        <img src={logo} alt="Pelican Planner" className="mobile-header-logo" />
        <span className="mobile-header-title">Pelican Planner</span>
      </Link>
      <button className="mobile-header-logout" onClick={onLogout} title="Sign Out">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
      </button>
    </header>
  );
}

export default MobileHeader;
